export default __webpack_public_path__ + "atomic/_patterns/01-atoms/timeline-item-title/_timeline-item-title.twig";